import Image from "components/Elements/Image/Image";
import { useContent } from "contexts/contentContext/contentContext.js";
import styles from "./styles.module.scss";

export const EmbedFormMissingTid = () => {
  const { getHtmlByKey } = useContent();
  return (
    <div className={styles.wrapper}>
      <Image
        name="personal/off"
        ext="svg"
        className={styles.image}
        alt="missing tid logo"
        title="tid param is missing"
      />
      <p className={styles.title}>{getHtmlByKey("tid-is-missing")}</p>
    </div>
  );
};
